import createImageGalleryApi from './provider';

const EVENT_ENTITY_TYPE = 3;

const { get, add, update, remove } = createImageGalleryApi(EVENT_ENTITY_TYPE);
export { get, add, update, remove };